import React from 'react'
import '../styles/global.scss'
import styles from '../styles/Skills.module.scss'

export const Skills = () => {
    const mainSkillsData = ['HTML', 'CSS', 'JavaScript', 'React', 'VTEX']
    const secondarySkillsData = ['Python', 'NodeJs', 'MySQL', 'MongoDB', 'React Native']
    const certification = [
        {
            name: 'Developing AI Applications with Python and Flask',
            institution: 'IBM + Coursera',
            period: '2023',
            link: 'https://www.coursera.org/account/accomplishments/verify/J865WP689BAS'
        },
        {
            name: 'Python for Data Science, AI & Development',
            institution: 'IBM + Coursera',
            period: '2023',
            link: 'https://www.coursera.org/account/accomplishments/verify/939NAPVSUA9E'
        },
        {
            name: 'Developing Back-End Apps with Node.js and Express',
            institution: 'IBM + Coursera',
            period: '2023',
            link: 'https://www.coursera.org/account/accomplishments/verify/CUJJG5SSWPMB'
        },
        {
            name: 'The Frontend Career Path',
            institution: 'Scrimba',
            period: '2022 - 2023',
            link: 'https://scrimba.com/certificate/ugZvQrCr/gfrontend'
        },
        {
            name: 'Programa Oracle Next Education',
            institution: 'Oracle + Alura',
            period: '2021 - 2022',
            link: 'https://cursos.alura.com.br/program/certificate/094855e8-13e0-4333-854e-f59bfdda3ab1'
        },
        {
            name: 'Responsive Web Design',
            institution: 'FreeCodeCamp',
            period: '2021',
            link: 'https://www.freecodecamp.org/portuguese/certification/ailuj_ailuj/responsive-web-design'
        }
    ]
    
    return (
        <div id='skills' className='container'>
            <h2 className='title'>Habilidades</h2>
            <h3 className={styles.subtitle}>Primárias</h3>
            <div>
                {mainSkillsData.map((skill) => 
                    <span className={styles.skill}>{skill}</span>
                )}
            </div>
            <h3 className={styles.subtitle}>Secundárias</h3>
            <div>
                {secondarySkillsData.map((skill) => <span className={styles.skill}>{skill}</span>)}
            </div>
            <h3 className={styles.subtitle}>Certificações</h3>
                {certification.map((item) => {
                    return (
                        <div className={styles.certification}>
                        <span className={styles.period}>{item.period}</span><a className={styles.link} href={item.link} target='_blank' rel="noreferrer"><span className={styles.certificationTitle}>{item.name}</span></a>
                        <span className={styles.institution}>{item.institution}</span>
                        </div>
                    )
                })}
        </div>
    )
}